export const GET_FLEXIBLE_BENEFITS_SETTINGS = 'GET_FLEXIBLE_BENEFITS_SETTINGS';
export const UPDATE_FLEXIBLE_BENEFITS_SETTINGS = 'UPDATE_FLEXIBLE_BENEFITS_SETTINGS';
export const GET_ADVANCED_FLEXIBLE_BENEFITS_WINDOW = 'GET_ADVANCED_FLEXIBLE_BENEFITS_WINDOW';
export const UPDATE_ADVANCED_FLEXIBLE_BENEFITS_WINDOW = 'UPDATE_ADVANCED_FLEXIBLE_BENEFITS_WINDOW';
export const DELETE_ADVANCED_FLEXIBLE_BENEFITS_WINDOW = 'DELETE_ADVANCED_FLEXIBLE_BENEFITS_WINDOW';
